import { createContext, useContext, type ReactNode } from 'react';
import { organisationsApi, organisationsApiFetchClient } from './organisations-api/organisationsApi';
import { switchboardAi } from './switchboard-ai/switchboardAi';
import { switchboardApiFetchClient } from './switchboard-api/switchboardApi';
import { switchboardAiFetchClient } from './switchboard-ai/switchboardAi';
import { versoriApi, versoriApiFetchClient } from './versori-api/versoriApi';

export const services = {
  organisationsApi: organisationsApi,
  organisationsApiFetch: organisationsApiFetchClient,

  switchboardAi: switchboardAi,
  switchboardAiFetch: switchboardAiFetchClient,

  switchboardApiFetch: switchboardApiFetchClient,

  versoriApi: versoriApi,
  versoriApiFetch: versoriApiFetchClient,
};

export type Services = typeof services;

// Create a context for multiple API clients
const MultipleServiceAPIClientsContext = createContext<Services>(null!);

export default function MultipleAPIClientsApp({ children }: { children: ReactNode }) {
  return (
    <MultipleServiceAPIClientsContext.Provider value={services}>{children}</MultipleServiceAPIClientsContext.Provider>
  );
}

export function useServices() {
  const context = useContext(MultipleServiceAPIClientsContext);

  if (!context) {
    throw new Error('useApi must be used within a MultipleAPIClientsApp');
  }

  return context;
}
